/* Horizon supplies the freshly rendered document with variant:update. No extra fetch or SKU guessing. */
class BriconauticaVariantDescription extends HTMLElement {
  connectedCallback() { document.addEventListener('variant:update', this.onVariantUpdate); }
  disconnectedCallback() { document.removeEventListener('variant:update', this.onVariantUpdate); }
  onVariantUpdate = (event) => {
    const detail=event.detail||{},data=detail.data||{};
    if(String(data.productId||'')!==this.dataset.productId)return;
    if(!detail.resource?.id){this.innerHTML='<p>Seleziona una combinazione di varianti disponibile.</p>';this.dataset.variantId='';return;}
    const incoming=[...(data.html?.querySelectorAll('briconautica-variant-description')||[])].find(el=>el.dataset.productId===this.dataset.productId&&el.dataset.blockId===this.dataset.blockId&&el.dataset.variantId===String(detail.resource.id));
    if(!incoming){this.innerHTML='<p>Descrizione non disponibile per questa variante.</p>';this.dataset.variantId='';return;}
    this.innerHTML=incoming.innerHTML;
    this.dataset.variantId=incoming.dataset.variantId;
  };
}
if(!customElements.get('briconautica-variant-description'))customElements.define('briconautica-variant-description',BriconauticaVariantDescription);
